import Button from 'src/components/atoms/Button';
import styled from 'styled-components/macro';

export const Container = styled.div`
  display: flex;
`;

export const LeftSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem;

  @media ${({ theme }) => theme.device.mobile} {
    padding: 2rem;
  }
`;

export const RightSection = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem;

  @media ${({ theme }) => theme.device.mobile} {
    padding: 2rem;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const StyledButton = styled(Button)`
  padding: 2rem;
  width: fit-content;
  border-radius: 40px;
  color: #012c57;
  background: #f2f6fb;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border: none;
  svg {
    path {
      fill: #012c57;
    }
  }

  &:hover {
    background: #012c57;
    color: white;

    svg {
      path {
        fill: white;
      }
    }
  }
`;

export const IllustrationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 500px;

  img {
    width: 100%;
    height: auto;
    max-width: 400px;
  }
`;
